import { ValueTextPair } from 'src/app/shared/models/value-text-pair';

/** 嚼檳榔代碼，同 OralScreeningCase.ChewingBetelNuts / PatientHIS.ChewingBetelNuts */
export const ChewingBetelNutsPair: ValueTextPair[] = [
  { text: '無', value: '0' },
  { text: '已戒', value: '1' },
  { text: '嚼10年以下，每天少於20顆', value: '2' },
  { text: '嚼10年以下，每天20顆及以上', value: '3' },
  { text: '嚼超過10年，每天少於20顆', value: '4' },
  { text: '嚼超過10年，每天20顆及以上', value: '5' }
];
/** 吸菸代碼，同 OralScreeningCase.Smoking / PatientHIS.Smoking */
export const SmokingPair: ValueTextPair[] = [
  { text: '無', value: '0' },
  { text: '已戒', value: '1' },
  { text: '吸10年以下，每天少於20支', value: '2' },
  { text: '吸10年以下，每天20支及以上', value: '3' },
  { text: '吸超過10年，每天少於20支', value: '4' },
  { text: '吸超過10年，每天20支及以上', value: '5' }
];
/** 基資用：首筆空白代表未填（口篩為必填，不可用此組） */
export const ChewingBetelNutsWithBlankPair: ValueTextPair[] = [{ text: '', value: '' }, ...ChewingBetelNutsPair];
export const SmokingWithBlankPair: ValueTextPair[] = [{ text: '', value: '' }, ...SmokingPair];
